import plugin from './src/plugin';

export { default as value } from './src/value';
export { default as config } from './src/config';
export { default as video } from './packages/video';
export { default as pop } from './packages/pop';
export { default as notifyPop } from './packages/notify-pop';
export { default as messageBox } from './packages/message-box';
export { default as toast } from './packages/toast';

export { request, getRequestDataReq } from './src/request';

export default plugin;
